import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Autocomplete } from "@nn-design-system/react-component-library";
import { useScrollToTopErrorInput } from "../../CustomHooks/useScrollToTopErrorInput";
import useGetListOfCountries from "../../CustomHooks/useGetListOfCountries";
import SingleLineContainer from "../ReportFormTemplate/SingleLineContainer";

type CountryAutocompleteFieldProps = {
   labelText: string;
   placeholderText: string;
   value: string | null;
   validationText?: string;
   dependencyValue: boolean;
   fieldNameForScroll: string;
   onChange: (value: string) => void;
   reserveSecondColumn?: boolean;
};

const CountryAutocompleteField = ({
   labelText,
   placeholderText,
   value,
   validationText,
   dependencyValue,
   fieldNameForScroll,
   onChange,
   reserveSecondColumn = true,
}: CountryAutocompleteFieldProps) => {
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameForScroll);
   const { listOfCountries } = useGetListOfCountries();

   useEffect(() => {
      if (value === "" || value == null) {
         onChange("Česká republika");
      }
   }, []);

   const field = (
      <Box
         sx={{
            position: "relative",
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
               borderColor: "black",
            },
            "& > div > div > div > div > div": {
               height: "3rem",
            },
         }}
         ref={ref}
      >
         <Autocomplete
            variant="Select"
            labelText={labelText}
            placeholderText={placeholderText}
            options={
               listOfCountries?.map((country: string) => ({
                  text: country,
                  value: country,
               })) ?? []
            }
            value={value || ""}
            onChange={(e) => {
               if (e.target.value) {
                  onChange(e.target.value.toString());
               }
            }}
            onBlur={(e) => {
               if (e.target.value) {
                  onChange(e.target.value.toString());
               }
            }}
            validationText={validationText}
         />
      </Box>
   );

   return reserveSecondColumn ? (
      <SingleLineContainer dependencyValue={dependencyValue}>
         {field}
      </SingleLineContainer>
   ) : dependencyValue ? field : null;
};

export default CountryAutocompleteField;
